import React from 'react';
import UploadImpressionTab from '../../components/UploadImpressionTab/UploadImpressionTab';
import ImpressionViewer from '../../components/PatientInfo/ImpressionViewer';
import { useLang } from '../../util/lang';
import styles from '../RestorativePhaseCaseIntake.module.css';

/** Maps a restorative STL section to the shared read-only impression viewer format. */
const createReadOnlyFileImpression = (data, fields) => ({
    ...data,
    type: 'FILE',
    stl_file0: data[fields[0]],
    stl_file1: data[fields[1]],
    stl_file2: data[fields[2]],
    stl_files_later: false,
});

/** Keeps the saved impression method while normalizing STL fields for read-only display. */
const createReadOnlyCaseImpression = (data) => ({
    ...data,
    type: data.type || 'FILE',
    stl_file0: data.stl_file0,
    stl_file1: data.stl_file1,
    stl_file2: data.stl_file2,
    stl_files_later: false,
});

const hasReadOnlyFiles = (data, fields) => fields.some((field) => Boolean(data[field]));

/** Renders Impression uploads in editable or read-only mode. */
const ImpressionStep = ({
    caseId,
    get,
    hasMockupOrder,
    isToothShapeRequired,
    readOnly = false,
    data = {},
    mockupImpression,
}) => {
    const languageGet = useLang();
    const translate = get || languageGet;
    if (readOnly) {
        const toothShapeImpression = createReadOnlyCaseImpression(data);
        const mockupFields = ['mockupUpperStl', 'mockupLowerStl', 'mockupBiteStl'];
        const resolvedMockupImpression =
            mockupImpression ||
            (hasReadOnlyFiles(data, mockupFields) ? createReadOnlyFileImpression(data, mockupFields) : null);
        return (
            <div className={styles.content}>
                <div className="restorative-section-heading" style={{ fontSize: 20 }}>
                    {translate('@PatientInfo.smileDesign.restorativePhase.toothShapeAdjustments')}
                    {isToothShapeRequired && <span style={{ color: '#f44336' }}> *</span>}
                </div>
                <ImpressionViewer caseImpression={toothShapeImpression} hideBiteTwo />
                {resolvedMockupImpression && (
                    <>
                        <div className="restorative-section-heading" style={{ fontSize: 20 }}>
                            {translate('@PatientInfo.smileDesign.restorativePhase.mockupAdjustments')}
                        </div>
                        <ImpressionViewer caseImpression={resolvedMockupImpression} hideBiteTwo />
                    </>
                )}
            </div>
        );
    }

    return (
        <>
            <div className={styles.heading}>{translate('@PatientInfo.smileDesign.restorativePhase.impressionTitle')}</div>
            <div className={styles.subheading}>{translate('@PatientInfo.smileDesign.restorativePhase.stepThree')}</div>
            <div className={styles.description}>{translate('@PatientInfo.smileDesign.restorativePhase.impressionDescription')}</div>
            <UploadImpressionTab
                caseId={caseId}
                mode="restorative"
                hasMockupOrder={hasMockupOrder}
                isToothShapeRequired={isToothShapeRequired}
            />
        </>
    );
};

export default ImpressionStep;
